import { AUTH_ROUTE_ID } from '@/integrations/tanstack-router/auth-route-id';

export const ACCOUNT_MAINTENANCE_ROUTES = {
  index: '/account-maintenance',
} as const;

export const ACCOUNT_MAINTENANCE_ROUTE_IDS = {
  index: `/${AUTH_ROUTE_ID}${ACCOUNT_MAINTENANCE_ROUTES.index}`,
} as const;
